import React from 'react';
import { createComponent } from '@lit/react';
import { IxSecondaryTab as LitComp } from '../IxSecondaryTab.js';

customElements.define('ix-secondary-tab', LitComp);

export const IxSecondaryTab = createComponent({
  tagName: 'ix-secondary-tab-react',
  elementClass: LitComp,
  react: React,
});
